/**
 * Where to go after logging in: the page someone was sent to the login page
 * from, e.g. an app's OAuth consent page
 *
 * Kept in sessionStorage, because logging in with Google or GitHub can leave
 * the page. Only paths on this site are kept
 */

const KEY = 'jsonpad.returnTo';

function isLocalPath(value: string | null): value is string {
  return (
    !!value &&
    value.startsWith('/') &&
    !value.startsWith('//') &&
    !value.startsWith('/\\')
  );
}

export function setReturnTo(path: string): void {
  if (!isLocalPath(path)) {
    return;
  }
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    // Without storage, login goes to the dashboard
  }
}

/**
 * The page to return to, without forgetting it
 */
export function peekReturnTo(): string | null {
  try {
    const value = sessionStorage.getItem(KEY);
    return isLocalPath(value) ? value : null;
  } catch {
    return null;
  }
}

/**
 * The page to return to, forgetting it
 */
export function takeReturnTo(): string | null {
  const value = peekReturnTo();
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing to forget
  }
  return value;
}
